import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { CatalogueRollout, rolloutRefetchInterval } from "./catalogueDeployments";
import { CatalogueQuery } from "../components/CatalogueList";

export type ExerciseListItem = {
  exercise_id: number;
  name: string;
  target_joints?: string[] | null;
  updated_at?: string | null;
  creator_id?: number | null;
  rollout?: CatalogueRollout;
  levels: {
    title?: string | null;
    image_url?: string | null;
    video_thumbnail_file_url?: string | null;
    position?: string | null;
    movement?: string | null;
  }[];
};

type ExerciseListResponse = {
  items: ExerciseListItem[];
  metadata: {
    total_count: number;
    page?: number;
    next?: number | null;
    prev?: number | null;
    page_items?: number;
  };
};

type GetExercisesParams = CatalogueQuery & {
  positions: string[];
  movements: string[];
  equipments: string[];
};

const buildQuery = (params: GetExercisesParams): string => {
  const qs = new URLSearchParams();
  qs.set("locale", params.locale);
  qs.set("page", String(params.page + 1));
  qs.set("limit", String(params.limit));
  if (params.search.trim()) qs.set("search", params.search.trim());
  params.joints.forEach(j => qs.append("joint", j));
  params.positions.forEach(p => qs.append("position", p));
  params.movements.forEach(m => qs.append("movement", m));
  params.equipments.forEach(e => qs.append("equipment", e));
  return qs.toString();
};

export const useGetExercises = (params: GetExercisesParams) =>
  useQuery<ExerciseListResponse>(
    queryKeys.getExercises(params),
    () =>
      // @ts-ignore
      api.parse(`GET /exercises?${buildQuery(params)}`, { root: supportApiBase }),
    { keepPreviousData: true, refetchInterval: data => rolloutRefetchInterval(data?.items) }
  );
